const csvTemplate = `customer_code,sku,year
TGR1-10064,AU.SC-SPMW1001,2026
TGR1-10064,AU.SC-SPDCCF1,2026`;

export default csvTemplate;
